import {parseQueryString} from 'shared/utils';

export const onWebview = () => parseQueryString(location.search.slice(1)).webview === 'true';

export const queryParamsToString = (queryParams = {}) =>
  Object.keys(queryParams)
    .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
    .join('&');
